import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "DoubleArrow",
  "use": "DoubleArrow-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"DoubleArrow\"><defs><style>#DoubleArrow .cls-1{fill:none;stroke:#231f20;stroke-miterlimit:10;stroke-width:30px}</style></defs><path class=\"cls-1\" d=\"M334.83 69.15L200 203.98 65.17 69.15\" /><path class=\"cls-1\" d=\"M334.83 192.06L200 326.89 65.17 192.06\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol